export const APP_SIZES = {
  '48': '3rem',
  '32': '2rem',
  '24': '1.5rem',
  '20': '1.25rem',
  '18': '1.125rem',
  '16': '1rem',
  '14': '0.875rem',
  '12': '0.75rem'
};

export const APP_COLORS = {
  warning: '#FFC200',
  success: '#7BC67E',
  danger: '#FF5B5B',
  'dark-gray': '#183B56',
  'dark-green': '#5A7184',
  'border-base': '#D8E0F0',
  orange: '#FF7F4E',
  gray: '#6C7A96',
  white: '#ffffff',
  'text-inverse': '#A4B2CE',
  'card-title': '#002366',
  divider: 'rgba(37, 82, 243, 0.5)',
  'error-dark': '#D80000',
  'error-100': '#F50057',
  'error-50': '#FF7394',
  'error-5': '#FFF0F5',
  'primary-hover': '#25A467',
  'primary-dark': '#0B1A30',
  'primary-100': '#3C66F9',
  'primary-80': '#48CA8C',
  'primary-20': '#A6EECB',
  'primary-10': '#C8D3FD',
  'primary-5': '#E4FAEF',
  primary: '#3762FA',
  secondary: '#1F2F44',
  'secondary-1': '#4F84E8',
  'secondary-5': '#EEF4FF',
  'secondary-hover': '#3B70D7',
  'layout-bg': '#F9FAFD',
  'text-100': '#18212C',
  'text-80': '#63687A',
  'text-60': '#A4A8B5',
  'text-40': '#C6C9D1',
  'text-20': '#DBDDE2',
  'text-10': '#F5F6F8',
  'text-5': '#FBFBFB',
  'elements-1': '#FFA25C',
  'elements-2': '#78C3BF',
  'elements-3': '#1F2F44',
  'elements-4': '#D59315',
  'elements-5': '#599693',
  'elements-light': '#FFF5ED',
  'elements-light-2': '#EBFAF9'
};

export const APP_FONT_WEIGHT = {
  '100': '100',
  '200': '200',
  '300': '300',
  '400': '400',
  '500': '500',
  '600': '600',
  '700': '700',
  '800': '800',
  '900': '900',
  bold: 'bold'
};

export const APP_ALIGN = {
  left: 'left',
  center: 'center',
  right: 'right'
};
